import React from 'react'

import { Text, TextName } from 'sdk'

import type { SoundcoreCapabilitiesCmsContent } from 'core/services/cms/interfaces'

import { CapabilitiesCard } from '../../components/capabilities-card/CapabilitiesCard'
import cardClasses from '../../components/capabilities-card/CapabilitiesCard.module.scss'

import classes from './CapabilitiesSection.module.scss'


interface CapabilitiesSectionProps {
  content: SoundcoreCapabilitiesCmsContent
}

const renderTitle = (title: string): React.ReactNode => {
  const lines = title.split('\n')

  return lines.flatMap((line, index) => (
    index === 0? [line]: [<br key={`break-${index}`} className={cardClasses.desktopBreak} />, line]
  ))
}

const CapabilitiesSection: React.FC<CapabilitiesSectionProps> = ({ content }) => {
  return (
    <section className={classes.capabilitiesSection}>
      <Text type={TextName.H2} className={classes.heading}>
        {content.title}
      </Text>
      <div className={classes.cards}>
        {content.cards.map((card) => (
          <CapabilitiesCard
            key={card.title}
            title={renderTitle(card.title)}
            desktopImage={card.desktopImageUrl}
            mobileImage={card.mobileImageUrl}
          />
        ))}
      </div>
    </section>
  )
}

export default CapabilitiesSection
